import { Box, Button, Typography } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { ReactComponent as Close } from "../../../../assets/icons/boxed-close.svg";
import Image from "../../../../assets/images/default-img.jpg";
import { useGlobalContext } from "../../../../context/GlobalContext";
import { getIcon } from "../../../../utils/iconConfig";
import Card from "../../card-templates/Card";
import CustomTooltip from "../../CustomTooltip";
import ImageModal from "../../modals/imageModal/ImageModal";
import LogoutandDeleteModal from "../../modals/LogoutandDeleteModal/LogoutandDeleteModal";
import SearchModal from "../../modals/searchModal/SearchModal";
import SetModal from "../../modals/setModal/SetModal";
import LongCardSkeleton from "../../skeletons/longCardSkeleton";
import { useItemSizes } from "./apis/itemSize";
import "./longCard.css";
import { formatDate } from "../../../../utils/convertDate";

const LongCard = ({
  data,
  modifyData,
  handleClose,
  setIcon,
  onDelete,
  displayData,
  checkSetQualityMatch,
  modify,
  apply,
}) => {
  const { categoryName, subCategoryName } = data || {};

  const {
    cartScreen,
    filterModify,
    setCartData,
    proceedClick,
    setProceedClick,
    cartData,
    handleAddToCart,
    handleRemoveFromCart,
  } = useGlobalContext();

  const location = useLocation();

  const isCartPage = location.pathname === "/cart";

  const [giantModal, setGiantModal] = useState(false);

  const [details, setDetails] = useState([]);

  const [remark, setRemark] = useState(modifyData?.message);

  const [searchModal, setSearchModal] = useState(false);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [size, setSize] = useState(modifyData?.itemSize);
  const [rhodium, setRhodium] = useState(modifyData?.rhodium || "W");
  const [itemPoNo, setitemPoNo] = useState(modifyData?.itemPoNo || "");
  const [isColorDropdownOpen, setIsColorDropdownOpen] = useState(false);

  const rhodiumOptions = ["White", "Pink", "Yellow"];
  const rhodiumMap = {
    White: "W",
    Pink: "P",
    Yellow: "Y"

  };

  const reverseRhodiumMap = Object.fromEntries(Object.entries(rhodiumMap).map(([key, value]) => [value, key]));

  let bgColor = "#000";
  let fontColor = "#fff";

  if (rhodium === "Y") {
    bgColor = "#171300";
    fontColor = "#FFD700";
  } else if (rhodium === "W") {
    bgColor = "#262626";
    fontColor = "#fff";
  } else if (rhodium === "P") {
    bgColor = "#150814";
    fontColor = "#E77B7B";
  }

  const [goldQlty, setGoldQlty] = useState(
    `${modifyData?.goldQty}-${modifyData?.goldColor}`
  );

  const [diamondQlty, setDiamondQlty] = useState(modifyData?.diaQty);

  const [imageModal, setImageModal] = useState({
    isOpen: false,
    imgUrl: null,
    styleNumber: null,
    allData: null,
  });

  const [currentIndex, setCurrentIndex] = useState(
    cartData?.findIndex((item) => item?.styleNumber === data?.styleNumber)
  );

  const isFirstItem = currentIndex === 0;
  const isLastItem =
    currentIndex === cartData?.length - 1 || cartData?.length === 0;

  const [deleteModal, setDeleteModal] = useState({ open: false, data: null });

  const goldData = ["18-P", "18-W", "18-Y", "14-P", "14-W", "14-Y"];

  const diamondData = [
    "VVS-EF",
    "VVS-FG",
    "VVS-GH",
    "VS-GH",
    "VSSI-GH",
    "SI-HI",
    "SI-IJ",
  ];

  const handleOpenImageModal = useCallback((imgUrl, styleNumber) => {
    setImageModal({ isOpen: true, imgUrl, styleNumber });
  }, []);

  const handleCloseImageModal = useCallback(() => {
    setImageModal({ isOpen: false, imgUrl: null, styleNumber: null });
  }, []);

  const handleOpenDeleteModal = useCallback((data) => {
    setDeleteModal({ open: true, data });
  }, []);

  const handleCloseDeleteModal = useCallback(() => {
    setDeleteModal({ open: false, data: null });
  }, []);

  const handleNextClick = () => {
    if (currentIndex < cartData?.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      const nextItem = cartData[newIndex];

      setImageModal({
        isOpen: true,
        imgUrl: nextItem?.imageUrl || null,
        styleNumber: nextItem?.styleNumber,
        allData: nextItem,
      });
    }
  };

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      const prevItem = cartData[newIndex];

      setImageModal({
        isOpen: true,
        imgUrl: prevItem?.imageUrl || null,
        styleNumber: prevItem?.styleNumber,
        allData: prevItem,
      });
    }
  };

  const { data: sizeData } = useItemSizes({ categoryName, subCategoryName });

  const showDetails = useMemo(
    () => [
      {
        left: [
          {
            label: data?.styleNumber,
            Icon: getIcon(data?.designClass),
            tooltipTitle: null,
          },
          {
            label: `${data?.netWeight} g / ${data?.grossWeight} g `,
            Icon: getIcon("GoldBar"),
            tooltipTitle: "Gold Net Weight / Gold Gross Weight",
          },
          {
            label: `${data?.diaWeight} Ct / ${data?.diaPcs} Pcs`,
            Icon: getIcon("Diamond"),
            tooltipTitle: "Diamond Weight / Diamond Pieces",
          },
          {
            label: `${data?.colorStoneWeight ?? 0} Ct / ${data?.colorStonePcs ?? 0} Pcs`,
            Icon: getIcon("GemStone"),
            tooltipTitle: "ColorStone Weight / ColorStone Pieces",
          },
          {
            label: `${data?.otherMaterialWeight ?? 0} Ct / ${data?.otherMaterialPcs ?? 0} Pcs`,
            Icon: getIcon("OtherMaterial"),
            tooltipTitle: "OtherMaterial Weight / OtherMaterial Pieces",
          },
          {
            label: `${data?.totalSales ?? 0}`,
            Icon: getIcon("Sale"),
            tooltipTitle: "Sales",
          },
          {
            label: `${formatDate(data?.styleDate)}`,
            Icon: getIcon("Calender"),
            tooltipTitle: "Design Creation Date",
          },
          ...(!cartScreen
            ? [
              {
                // label: `${size}`,
                label: `${modifyData?.itemSize || "N/A"}`,
                Icon: getIcon("Scale"),
                tooltipTitle: "Size",
              },
            ]
            : []),
        ],
      },
      {
        middle: [
          ...(setIcon
            ? [
              {
                Icon: getIcon("Sets", checkSetQualityMatch ? "green" : ""),
                tooltipTitle: "Sets",
              },
            ]
            : []),
        ],
      },
    ],
    [data, displayData]
  );

  useEffect(() => {
    setDetails(showDetails);
    setGoldQlty(`${modifyData?.goldQty}-${modifyData?.goldColor}`);
    setSize(modifyData?.itemSize);
    setDiamondQlty(modifyData?.diaQty);
    setRemark(modifyData?.message);
    setRhodium(modifyData?.rhodium || "W")
    return () => {
      setProceedClick([]);
    };
  }, [modifyData]);

  useEffect(() => {
    if (modify || apply) return;

    let getCartData = JSON.parse(localStorage.getItem("cartItems")) || [];

    const updatedCartData = getCartData?.map((item) => {
      if (item?.styleNumber === data?.styleNumber) {
        const updatedQuantityData = item?.quantityData?.map((q) => {
          if (q?.key === modifyData?.key) {
            return {
              ...q,
              itemSize: size,
              goldColor: goldQlty?.split("-")[1] || q?.goldColor,
              goldQty: goldQlty?.split("-")[0] || q?.goldQty,
              diaQty: diamondQlty || q?.diaQty,
              message: remark != null ? remark.trim() : q?.message,
              rhodium: rhodium || "W",
              itemPoNo: itemPoNo || ""
            };
          }
          return q;
        });

        return {
          ...item,
          quantityData: updatedQuantityData,
        };
      }
      return item;
    });

    localStorage.setItem("cartItems", JSON.stringify(updatedCartData));
    setCartData(updatedCartData);
  }, [goldQlty, diamondQlty, size, remark, apply, rhodium, itemPoNo]);

  const handleApplyClick = () => {
    if (!sizeData || !modify) return;

    let getCartData = JSON.parse(localStorage.getItem("cartItems")) || [];

    const updatedCartData = getCartData?.map((item) => {
      if (item?.styleNumber === data?.styleNumber) {
        const updatedQuantityData = item?.quantityData?.map((q) => {
          return {
            ...q,
            itemSize: size,
            rhodium,
            itemPoNo: itemPoNo || "",
            goldColor: goldQlty?.split("-")[1] || q?.goldColor,
            goldQty: goldQlty?.split("-")[0] || q?.goldQty,
            diaQty: diamondQlty || q?.diaQty,
            message: remark != null ? remark.trim() : q?.message,
          };
        });

        return {
          ...item,
          itemSize: size,
          rhodium,
          itemPoNo: itemPoNo || "",
          quantityData: updatedQuantityData,
          sizeAvailable: sizeData?.length > 0,
        };
      }
      return item;
    });

    localStorage.setItem("cartItems", JSON.stringify(updatedCartData));
    setCartData(updatedCartData);
  };

  const isBracelet = ["Gents Bracelets", "Ladies Bracelets"].includes(
    data?.categoryName
  );

  const isSpecialKada = ["Oval Kada", "Sardar Kada"].includes(
    data?.subCategoryName
  );

  const onlyANI = useMemo(
    () => isBracelet && isSpecialKada && filterModify?.size?.includes("ANI"),
    [filterModify?.size, isBracelet, isSpecialKada]
  );

  const onlyCM = useMemo(
    () => isBracelet && !isSpecialKada && filterModify?.size?.includes("CM"),
    [filterModify?.size, isBracelet, isSpecialKada]
  );

  useEffect(() => {
    if (!filterModify?.categories?.includes(categoryName)) return;

    setGoldQlty(filterModify?.goldValue);
    setDiamondQlty(filterModify?.diamondQuality);
    if (filterModify?.rhodium) {
      setRhodium(filterModify.rhodium);
    }

    if (filterModify?.size) {
      const shouldSetSize = onlyANI || onlyCM || !isBracelet;
      if (shouldSetSize) {
        setSize(filterModify.size);
      }
    }
  }, [filterModify]);

  return (
    <>
      {!sizeData ? (
        <LongCardSkeleton />
      ) : (
        <div
          style={{
            display: "flex",
            gap: ".5vw",
            background: "#0D0D0D",
            width: "48vw",
            height: "12.5vw",
            padding: ".75vw",
            borderRadius: ".25vw ",
          }}
        >
          <Card
            width="18.5vw"
            style={{
              borderRadius: ".35vw",
              border: ".05vw solid #C0C0C0",
              cursor: "auto",
              padding: ".75vw",
              height: isCartPage ? "10vw" : "11.2vw",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: ".3vw ",
              }}
              width={"103%"}
              height={"100%"}
            >
              <Box className="left">
                {details[0]?.left?.map((detail, index) => (
                  <Box
                    key={index}
                    className={`long-content-new long-content-new-${index}`}
                  >
                    {detail.Icon}
                    <CustomTooltip title={detail?.tooltipTitle}>
                      <Typography
                        className={`long-content-typo long-content-typo-${index}`}
                        ml={".5vw"}
                      >
                        {detail.label}
                      </Typography>
                    </CustomTooltip>
                  </Box>
                ))}
              </Box>
              {displayData?.length < 1 ? null : (
                <Box className="middle">
                  {details[1]?.middle?.map((detail, index) => (
                    <React.Fragment key={index}>
                      <Box
                        sx={{ cursor: "pointer" }}
                        className={`content-new content-new-${index}`}
                        onClick={() => setGiantModal(true)}
                      >
                        <CustomTooltip title={detail?.tooltipTitle}>
                          {detail?.Icon}
                        </CustomTooltip>
                      </Box>
                    </React.Fragment>
                  ))}
                </Box>
              )}
              <Box>
                <img
                  className="long-card-image"
                  style={{
                    marginTop: isCartPage ? "0px" : "10px",
                  }}
                  src={data?.transformedImageUrl || Image}
                  alt={data?.styleNumber}
                  onClick={() =>
                    handleOpenImageModal(
                      data?.imageUrl ? data?.imageUrl : null,
                      data?.styleNumber
                    )
                  }
                />
              </Box>
            </Box>
          </Card>
          <div
            style={{ width: "100%", position: "relative" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: ".5vw",
                marginTop: ".5vw",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "0.7vw" }}>
                <div
                  className="filter-select"
                  style={{
                    border:
                      proceedClick?.length > 0 &&
                        proceedClick?.some((item) => item === data?.categoryName) &&
                        data?.sizeAvailable &&
                        modifyData?.itemSize === ""
                        ? "0.05vw solid red"
                        : "0.05vw solid #262626",
                  }}
                >
                  <label htmlFor="">{getIcon("Scale", "dark")}</label>
                  <>
                    <select
                      value={size}
                      onChange={(e) => setSize(e.target.value)}
                      onClick={() => setIsDropdownOpen((prev) => !prev)}
                      onBlur={() => setIsDropdownOpen(false)}
                      disabled={sizeData?.length === 0}
                      style={{
                        color:
                          proceedClick?.length > 0 &&
                            proceedClick?.some((c) => c === data?.categoryName) &&
                            data?.sizeAvailable &&
                            modifyData?.itemSize === ""
                            ? "red"
                            : "white",
                      }}
                    >
                      <option value={""} disabled hidden>
                        {sizeData?.length >= 1 ? "Select Size" : "N/A"}
                      </option>
                      {sizeData?.map((size) => (
                        <option key={size} value={size}>
                          {size}
                        </option>
                      ))}
                    </select>
                    {sizeData?.length >= 1 ? (
                      <span
                        style={{
                          transform: isDropdownOpen
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                        className="down-label"
                      >
                        {getIcon("DownArrow")}
                      </span>
                    ) : null}
                  </>

                </div>

                <div
                  className="filter-select color-select"
                  id={`color-select-${data.styleNumber}`}
                >
                  <div>
                    <label>
                      {getIcon("Rhodium")}
                    </label>
                  </div>

                  <div
                    className="custom-select-value"
                    onClick={() => setIsColorDropdownOpen(!isColorDropdownOpen)}
                    style={{ background: bgColor, color: fontColor }}
                  >
                    {reverseRhodiumMap[rhodium]}
                  </div>

                  {isColorDropdownOpen && (
                    <ul className="custom-options">
                      {rhodiumOptions.map((c) => (
                        <li
                          key={c}
                          onClick={() => {
                            setRhodium(rhodiumMap[c]);
                            setIsColorDropdownOpen(false);
                          }}
                        >
                          {c}
                        </li>
                      ))}
                    </ul>
                  )}

                  <span
                    style={{
                      transform: isColorDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                    className="down-label"
                  >
                    {getIcon("DownArrow")}
                  </span>
                </div>

              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%", // Change from "fit-content" to "100%"
                  borderRadius: ".25vw",
                  height: "1.5vw",
                  border: ".05vw solid #262626",
                  borderRight: "none",
                  overflowY: "hidden",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "#000",
                    padding: "0 .25vw",
                    height: "100%",
                    borderTopLeftRadius: ".25vw",
                    borderBottomLeftRadius: ".25vw",
                  }}
                >
                  {getIcon("GoldBar", "dark")}
                </Box>
                <ToggleButtonGroup
                  color="primary"
                  exclusive
                  value={goldQlty}
                  onChange={(e, value) => value && setGoldQlty(value)}
                  sx={{
                    width: "100%", // Ensure it takes full width
                    height: "100%",
                    "& .MuiToggleButton-root:first-child": { borderRadius: 0 },
                    "& .MuiToggleButton-root:last-child": {
                      borderRadius: 0,
                      borderRight: "0.05vw solid #262626",
                    },
                    "& .MuiToggleButton-root ": {
                      borderTop: "none",
                      borderBottom: "none",
                      borderLeft: "0.05vw solid #262626",
                    },
                  }}
                >
                  {goldData.map((platform) => {
                    let bgColor = "#000";
                    let fontColor = "#fff";

                    if (platform.includes("Y")) {
                      bgColor = "#171300";
                      fontColor = "#FFD700";
                    } else if (platform.includes("W")) {
                      bgColor = "#262626";
                      fontColor = "#fff";
                    } else if (platform.includes("P")) {
                      bgColor = "#150814";
                      fontColor = "#E55CE3";
                    }

                    return (
                      <ToggleButton
                        key={platform}
                        value={platform}
                        style={{
                          fontSize: ".65vw",
                          fontFamily: "Karla",
                          fontWeight: "700",
                          whiteSpace: "nowrap",
                          background: goldQlty === platform ? bgColor : "#000",
                          color: goldQlty === platform ? fontColor : "#fff",
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: 0,
                        }}
                      >
                        {platform}
                      </ToggleButton>
                    );
                  })}
                </ToggleButtonGroup>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  height: "1.5vw",
                  borderRadius: ".25vw",
                  border: ".05vw solid #262626",
                  overflowY: "hidden",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    background: "#000",
                    padding: "0px .25vw",
                    height: "100%",
                    borderTopLeftRadius: ".25vw",
                    borderBottomLeftRadius: ".25vw",
                  }}
                >
                  {getIcon("Diamond", "dark")}
                </Box>
                <ToggleButtonGroup
                  color="primary"
                  exclusive
                  value={diamondQlty}
                  onChange={(e, value) => value && setDiamondQlty(value)}
                  sx={{
                    width: "100%",
                    height: "100%",
                    "& .MuiToggleButton-root:first-child": { borderRadius: 0 },
                    "& .MuiToggleButton-root:last-child": {
                      borderRadius: 0,
                      borderRight: 0,
                    },
                    "& .MuiToggleButton-root": {
                      borderTop: "none",
                      borderBottom: "none",
                      borderLeft: "0.05vw solid #262626",
                    },
                  }}
                >
                  {diamondData.map((platform, index) => {
                    return (
                      <ToggleButton
                        key={platform}
                        value={platform}
                        style={{
                          fontSize: ".65vw",
                          fontFamily: "Karla",
                          fontWeight: "700",
                          // padding: ".15vw .45vw",
                          whiteSpace: "nowrap",
                          background:
                            diamondQlty === platform ? "#07120B" : "#000",
                          color: diamondQlty === platform ? "#50C878" : "#fff",
                          // border: ".05vw solid #262626",
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: 0,
                        }}
                      >
                        {platform}
                      </ToggleButton>
                    );
                  })}
                </ToggleButtonGroup>
              </div>

              <div style={{ width: "28vw" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: ".5vw",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      height: "1.4vw",
                      width: "100%",
                      fontSize: ".5vw",
                      fontWeight: remark ? "500" : "600",
                      fontFamily: "Karla",
                      padding: ".25vw",
                      background: "#000",
                      color: remark ? "#EDEDEB" : "#333333",
                      borderRadius: ".25vw",
                      cursor: "pointer",
                      alignContent: "center",
                      letterSpacing: "0vw",
                      whiteSpace: "nowrap", // prevent wrapping
                      overflow: "hidden", // hide overflow
                      textOverflow: "ellipsis", // show "..."
                    }}
                    onClick={() => setSearchModal(true)}
                  >
                    {remark || "Enter your message"}
                  </div>

                  {!cartScreen && (
                    <Button
                      sx={{
                        background: "#50C878",
                        color: "#000000",
                        height: "1.3vw",
                        width: "6vw",
                        fontSize: ".5vw",
                        fontWeight: "600",
                        padding: ".25vw",
                        borderRadius: ".25vw",
                      }}
                      onClick={() => {
                        handleApplyClick();
                        handleClose();
                      }}
                    >
                      APPLY
                    </Button>
                  )}
                </div>

                {/* PO Number Input */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: ".5vw",
                    border: ".05vw solid #262626",
                    borderRadius: ".25vw",
                    background: "#000",
                    height: "1.5vw",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      width: "1.8vw",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: ".05vw solid #262626",
                      height: "100%",
                    }}
                  >
                    {getIcon("PoNo")}
                  </div>

                  <input
                    type="text"
                    placeholder="Enter Item PO No."
                    value={itemPoNo}
                    onChange={(e) => setitemPoNo(e.target.value)}
                    style={{
                      flex: 1,
                      background: "transparent",
                      border: "none",
                      outline: "none",
                      color: "#fff",
                      fontSize: ".6vw",
                      padding: "0 .5vw",
                      fontFamily: "Karla",
                    }}
                  />
                </div>
              </div>
            </div>

            {!cartScreen ? (
              <Close
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  top: "-.5vw",
                  right: "0",
                  width: "1vw",
                  height: "1vw",
                }}
                onClick={handleClose}
              />
            ) : (
              <span
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  top: "-.5vw",
                  right: 0,
                  display: "flex",
                }}
                onClick={() => handleOpenDeleteModal(data)}
              >
                {getIcon("dustbin")}
              </span>
            )}
          </div>
        </div>
      )}

      <SetModal
        openModal={giantModal}
        handleClose={() => setGiantModal(false)}
        data={displayData}
      />

      <SearchModal
        headLabel="Message"
        openModal={searchModal}
        handleClose={() => setSearchModal(false)}
        setRemark={setRemark}
        remark={remark}
      />

      <ImageModal
        openModal={imageModal.isOpen}
        handleClose={handleCloseImageModal}
        data={imageModal}
        nextClick={() =>
          location?.pathname === "/home" ? handlePrevClick() : handleNextClick()
        }
        prevClick={() =>
          location?.pathname === "/home" ? handleNextClick() : handlePrevClick()
        }
        isAdded={cartData?.some(
          (item) =>
            String(item?.styleNumber)?.trim()?.toLowerCase() ===
            String(imageModal?.styleNumber)?.trim()?.toLowerCase()
        )}
        setIsAdded={(value) => {
          const currentDesign = cartData.find(
            (d) =>
              String(d?.styleNumber).trim().toLowerCase() ===
              String(imageModal?.styleNumber).trim().toLowerCase()
          );
          if (currentDesign) {
            value
              ? handleAddToCart(currentDesign)
              : handleRemoveFromCart(currentDesign);
          }
        }}
        hasNext={location?.pathname === "/home" ? !isFirstItem : !isLastItem}
        hasPrev={location?.pathname === "/home" ? !isLastItem : !isFirstItem}
      />

      <LogoutandDeleteModal
        openModal={deleteModal.open}
        handleClose={handleCloseDeleteModal}
        deleteItem={deleteModal?.data}
        onAction={onDelete}
        modalType={"delete"}
      />
    </>
  );
};

export default LongCard;

